<template>
  <div class="modal fade" data-backdrop="static" id="adjust-quantity" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-info bg-danger">
            <h3 class="block-title"><i class="fa fa-balance-scale text-white"></i> Adjust Quantity</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" @click.prevent="clearData()" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Label</label>
              <input type="text" v-model="label" name="label" v-validate="'required'" data-vv-as="Label" class="form-control form-control-alt" placeholder="Label">
              <p v-if="errors.has('label')" class="errorMsg">{{ errors.first('label') }}</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Quantity</label>
              <input type="number" name="quantity" min="1" onkeypress="return event.charCode >= 48" v-model="quantity" placeholder="Quantity" class="form-control form-control-alt">
              <p v-if="quantityError" class="errorMsg">The Quantity field is required.</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Unit Of Weight</label>
              <select id="adjust-quantity-measurement" placeholder="Select Unit Of Measurement.." class="form-control package-select2-dropdown" style="width: 100%;">
                <option></option>
                <option v-for="(unit, index) in library.unitOfMeasurement" :key="index" :bind:value="unit.Name">{{ unit.Name }}</option>
              </select>
              <p v-if="measurementError" class="errorMsg">The Unit Of Weight field is required.</p>
            </div>
            <div class="form-group">
              <label>Adjust Date</label>
              <input type="text" id="adjust-quantity-date" name="date" v-model="date" placeholder="Move Date" class="form-control form-control-alt datepicker">
            </div>
            <div class="form-group required">
              <label class="control-label">Adjustment Reason</label>
              <select id="adjust-reason" placeholder="Select Adjustment Reason.." class="form-control package-select2-dropdown" style="width: 100%;">
                <option></option>
                <option v-for="(reason, index) in library.adjustReasons" :key="index" :bind:value="reason.Name">{{ reason.Name }}</option>
              </select>
              <p v-if="adjustReasonError" class="errorMsg">The Adjustment Reason field is required.</p>
            </div>
            <div class="form-group">
              <label>Adjust Reason Note</label>
              <input type="text" v-model='adjustReasonNote' class="form-control form-control-alt" placeholder="Reason Note">
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click="adjustQuantity" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapActions, mapState } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'AdjustQuantity',
  data() {
    return {
      measurement: '',
      label: '',
      quantity: 1,
      adjustReason: '',
      adjustReasonNote: '',
      date: new Date().toJSON().slice(0,10),
      errorMsg: '',
      measurementError: false,
      adjustReasonError: false,
      quantityError: false,
      showModalLoader: false
    };
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  mounted() {
    let vm = this;
    $('#adjust-quantity-measurement').on('change', function () { vm.measurement = $(this).val(); vm.measurementError = false; } );
    $('#adjust-reason').on('change', function () { vm.adjustReason = $(this).val(); vm.adjustReasonError = false; } );
    $('.datepicker').datepicker({ format: 'yyyy-mm-dd', autoclose:true });
    $('#adjust-quantity-date').change(function() { vm.date = $(this).val(); });
  },
  components: {
    HashLoader
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    adjustQuantity() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validate() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest('/packages/adjust', {
            'Label' : vm.label,
            'Quantity' : vm.quantity,
            'AdjustmentReason' : vm.adjustReason,
            'ReasonNote' : vm.adjustReasonNote,
            'UnitOfMeasure' : vm.measurement,
            'AdjustmentDate' : vm.date
          }).then((data) => {
            if (data.status === 'success') {
              jQuery('#adjust-quantity').modal('hide');
              vm.$emit('showSuccessMsg', data.message);
              vm.showModalLoader = false;
              vm.clearData();
              vm.$emit('loadPackage', true);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    setData(label) {
      this.label = label;
    },
    clearData() {
      let vm = this;
      this.label = '';
      this.quantity = 1;
      this.measurement = '';
      this.adjustReason = '';
      this.adjustReasonNote = '';
      this.date = new Date().toJSON().slice(0,10);
      this.errorMsg = '';
      this.measurementError = false;
      this.adjustReasonError = false;
      this.quantityError = false;
      $('.package-select2-dropdown').val(null).trigger('change');
      $('.datepicker').datepicker('update', vm.date);
      this.$validator.reset();
    },
    validate() {
      if (!this.measurement) {
        this.measurementError = true;
      }

      if (!this.quantity) {
        this.quantityError = true;
      }

      if (!this.adjustReason) {
        this.adjustReasonError = true;
      }

      if(this.measurementError || this.quantityError || this.adjustReasonError) {
        return false;
      }

      return true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// source/components/modals/AdjustQuantity.vue